/* ==========================================================
   Auvelis product page behaviour
   Bundle price sync, add-to-cart into the slide-in cart,
   sticky buy bar, discount copy, delivery dates + countdown.
   ========================================================== */
(function () {
  function init() {
    var root = document.querySelector('.pdp');
    if (!root || root.hasAttribute('data-auv-pdp-ready')) return;
    root.setAttribute('data-auv-pdp-ready', '1');

    /* ---- copy discount code ---- */
    var codeBtn = root.querySelector('.pdp__promo-code');
    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.getAttribute('data-code') || '';
        var action = codeBtn.querySelector('.pdp__promo-code-action');
        function flash(msg) {
          if (!action) return;
          var prev = action.textContent;
          action.textContent = msg;
          codeBtn.classList.add('is-copied');
          setTimeout(function () {
            action.textContent = prev;
            codeBtn.classList.remove('is-copied');
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code)
            .then(function () { flash('Copied'); })
            .catch(function () { flash('Select it'); });
        } else {
          flash('Select it');
        }
      });
    }

    /* ---- shared element refs ---- */
    var priceEl = root.querySelector('#pdp-price');
    var wasEl = root.querySelector('#pdp-price-was');
    var tagEl = root.querySelector('#pdp-price-tag');
    var badgeEl = root.querySelector('#pdp-stage-badge');
    var atcPriceEl = root.querySelector('#pdp-atc-price');

    var sticky = document.getElementById('auv-sticky');
    var stickyPrice = sticky ? sticky.querySelector('[data-sticky-price]') : null;
    var stickyWas = sticky ? sticky.querySelector('[data-sticky-was]') : null;
    var stickyBtn = sticky ? sticky.querySelector('[data-sticky-add]') : null;

    function checked() {
      return root.querySelector('input[name="auv-tier"]:checked');
    }

    function syncPrice() {
      var c = checked();
      if (!c) return;
      var now = c.getAttribute('data-price-formatted') || '';
      var was = c.getAttribute('data-compare-formatted') || '';

      if (priceEl) priceEl.textContent = now;
      if (atcPriceEl) atcPriceEl.textContent = now;
      if (wasEl) wasEl.textContent = was;
      if (tagEl) tagEl.hidden = was === '';
      if (badgeEl) badgeEl.hidden = was === '';

      if (stickyPrice) stickyPrice.textContent = now;
      if (stickyWas) stickyWas.textContent = was;
    }

    root.querySelectorAll('input[name="auv-tier"]').forEach(function (i) {
      i.addEventListener('change', syncPrice);
    });
    syncPrice();

    /* ---- add to cart ---- */
    var form = root.querySelector('#pdp-form');
    var errEl = root.querySelector('.pdp__form-error');
    var atc = root.querySelector('.pdp__atc');

    function addToCart(button, busyHtml) {
      var c = checked();
      if (!c) {
        if (errEl) errEl.hidden = false;
        return;
      }
      if (errEl) errEl.hidden = true;

      var original = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.innerHTML = busyHtml;
      }

      function restore() {
        if (button) { button.disabled = false; button.innerHTML = original; }
      }

      function plainAdd() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: c.value, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        });
      }

      var p = (window.AuvCart && window.AuvCart.add)
        ? window.AuvCart.add(c.value, 1)
        : plainAdd();

      p.then(function () {
        restore();
        if (window.AuvCart && window.AuvCart.open) {
          window.AuvCart.open();
        } else {
          window.location.href = '/cart';
        }
      }).catch(function () {
        restore();
        if (errEl) errEl.hidden = false;
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(atc, '<span class="pdp__atc-top">Adding…</span>');
      });
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        addToCart(stickyBtn, '<span class="auv-sticky__btn-top">Adding…</span>');
      });
    }

    /* ---- sticky bar visibility ---- */
    if (sticky && atc) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-up', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        }, { threshold: 0 });
        io.observe(atc);
      } else {
        window.addEventListener('scroll', function () {
          var r = atc.getBoundingClientRect();
          var show = r.bottom < 0;
          sticky.classList.toggle('is-up', show);
        });
      }
    }

    /* ---- delivery dates + dispatch countdown ---- */
    function fmt(d) {
      return d.toLocaleDateString('en-AU', { month: 'short', day: 'numeric' });
    }
    function addDays(d, n) {
      var r = new Date(d);
      r.setDate(r.getDate() + n);
      return r;
    }
    var today = new Date();
    var shipEl = root.querySelector('.pdp-ship-date');
    var delEl = root.querySelector('.pdp-deliver-date');
    if (shipEl) shipEl.textContent = fmt(addDays(today, 1)) + ' – ' + fmt(addDays(today, 2));
    if (delEl) delEl.textContent = fmt(addDays(today, 2)) + ' – ' + fmt(addDays(today, 3));

    var cutoff = new Date();
    cutoff.setHours(17, 0, 0, 0);
    if (cutoff.getTime() < Date.now()) cutoff.setDate(cutoff.getDate() + 1);

    var cd = root.querySelector('.pdp-countdown');
    function tick() {
      if (!cd) return;
      var diff = cutoff.getTime() - Date.now();
      if (diff <= 0) { cd.textContent = '0 Hrs. 0 Min.'; return; }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      cd.textContent = h + ' Hrs. ' + m + ' Min.';
    }
    tick();
    setInterval(tick, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
